export default "__VITE_ASSET__CI9fPBZA__"